import React, { FC } from 'react';
import { View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import { connect } from 'react-redux';
import { OperationSearchItem } from '@interfaces/search';
import { SCREEN_PADDING_HORIZONTAL, SCREEN_PADDING_HORIZONTAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import { SingleJobOrList } from './components/SingleJobOrList';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { scale } from '@components/frame';

interface JobGeneralProps extends NavigationProps {
  jobId: number | null;
  jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>;
}

const JobGeneralComponent: FC<JobGeneralProps> = ({ lg, jobId, jobs }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={[{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL - SCREEN_PADDING_HORIZONTAL_FOR_ITEM), paddingTop: 0 }]}>
        <SingleJobOrList shouldTakeFromBatch jobs={jobs.data} jobId={jobId} loading={false} />
      </View>
    </MachinesProvider>
  );
};

const JobGeneral = connect(({ details: { jobId, jobs } }) => ({ jobId, jobs }), {})(JobGeneralComponent);

export { JobGeneral };
